import { EntryMethod } from 'components/enter/EntryMethod';
import { NextRouter } from 'next/router';

export const navigateToConfirmation = async (
  router: NextRouter,
  orderId: string | number,
  isTest: boolean = false,
  entryMethod?: EntryMethod,
  isFreeSubscription?: boolean
) => {
  if (isFreeSubscription) {
    await router.replace(`/confirmation?orderId=${orderId}`);
    return;
  }

  await router.replace(
    `/order-confirmation?orderId=${orderId}${entryMethod ? '&em=' + entryMethod : ''}`
  );
  return;
};
